import { render } from "./EmployeeAttendanceTrendsChart.vue?vue&type=template&id=352fd20e&ts=true"
import script from "./EmployeeAttendanceTrendsChart.vue?vue&type=script&lang=ts"
export * from "./EmployeeAttendanceTrendsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__